/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react';
import { Col, Container, Row, Stack } from 'react-bootstrap';
import { Course } from '../../../types/course.type';
import { CourseCard } from './CourseCard';
import './CourseCard.css';
import { CourseCardSimple } from './CourseCardSimple';

interface CourseResultsProps {
  courses: Course[];
  listView: boolean;
  onClick: (course: Course) => void;
  selectedCourseId?: number;
}

const CourseResults: React.FC<CourseResultsProps> = ({
  courses,
  listView = false,
  onClick,
  selectedCourseId
}) => {
  const visibleCourses =
      listView || selectedCourseId == null
          ? courses
          : courses.filter((course) => course.id !== selectedCourseId);

  let content = listView ? (
      <Row>
        {visibleCourses.map((c) => (
            <Col
                lg={3}
                sm={6}
                key={c.id}
                className="mb-3"
            >
              <CourseCardSimple course={c} />
            </Col>
        ))}
      </Row>
  ) : (
      <Stack gap={2}>
        {visibleCourses.map((c) => (
            <CourseCard
                key={c.id}
                course={c}
                onClick={() => onClick(c)}
            />
        ))}
      </Stack>
  );

  return (
      <div
          className={[
            'course-search-results-list',
            !listView ? 'course-search-map-results' : '',
            selectedCourseId != null && !listView ? 'has-selection' : ''
          ]
              .filter(Boolean)
              .join(' ')}
      >
        <Container
            fluid={!listView}
            className={listView ? 'multi-content-scroll-tall px-0' : 'multi-content-scroll px-0'}
        >
        <span>
          <b>{visibleCourses.length} Results</b> for filters
        </span>
          {content}
        </Container>
      </div>
  );
};

export default CourseResults;